import __request__ from 'routing/request';
interface EntityShareRequest {
    readonly selected_grantee_capabilities: {
        readonly [_key: string]: 'view' | 'manage' | 'own';
    };
    readonly selected_collections: string[];
}
interface EntityMembershipPolicyDTO {
    readonly initiator_id: string;
    readonly target_type: 'collection' | 'team';
    readonly target_id: string;
    readonly id: string;
    readonly initiator_type: 'team';
}
type EntityMembershipPolicyDTOArray = EntityMembershipPolicyDTO[];
type EntityMembershipPoliciesResource__CollectionInfoArray = EntityMembershipPoliciesResource__CollectionInfo[];
interface EntityMembershipPolicyUpdateRequest {
    readonly initiator_id: string;
    readonly target_type: 'collection' | 'team';
    readonly target_id: string;
    readonly initiator_type: 'team';
}
interface EntityMembershipPoliciesResource__CollectionInfo {
    readonly name: string;
    readonly id: string;
}
interface PaginatedResponse_EntityMembershipPolicyDTO {
    readonly [_key: string]: Object;
}
interface CreateEntityRequest_EntityMembershipPolicyDTO {
    readonly entity: EntityMembershipPolicyDTO;
    readonly share_request: EntityShareRequest;
}
/**
 * List all policies
 * @param page Page number to get
 * @param per_page Results per page
 * @param query Query string
 * @param sort The field to sort the result on
 * @param order The sort direction
 */
export function list(sort: 'initiator_id' | 'target_id' = 'initiator_id', page: number = 1, per_page: number = 50, query?: string, order: 'asc' | 'desc' = 'asc'): Promise<PaginatedResponse_EntityMembershipPolicyDTO> {
    return __request__('GET', '/plugins/org.graylog.plugins.collections/membership_policies', null, { 'page': page, 'per_page': per_page, 'query': query, 'sort': sort, 'order': order }, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new policy
 * @param request The policy to create
 */
export function create(request?: CreateEntityRequest_EntityMembershipPolicyDTO): Promise<EntityMembershipPolicyDTO> {
    return __request__('POST', '/plugins/org.graylog.plugins.collections/membership_policies', request, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Returns all default collections for the given user, having grants "own" or "manage".
 * @param userId The user ID to find th default collections for
 */
export function loadPermittedDefaultCollections(userId?: string): Promise<EntityMembershipPoliciesResource__CollectionInfoArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.collections/membership_policies/default_collections/${userId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get all policies for a specific initiator ID and type
 * @param initiatorType The initiator type
 * @param initiatorId The initiator ID
 */
export function getByInitiatorId(initiatorType: string, initiatorId: string): Promise<EntityMembershipPolicyDTOArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.collections/membership_policies/initiator', null, { 'initiatorType': initiatorType, 'initiatorId': initiatorId }, {
        'Accept': ['application/json']
    });
}
/**
 * Get a policy
 * @param policyId The ID of the policy to retrieve
 */
export function get(policyId?: string): Promise<EntityMembershipPolicyDTO> {
    return __request__('GET', `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update a policy
 * @param policyId The ID of the policy to update
 * @param updateRequest The update request object
 */
export function update(policyId?: string, updateRequest?: EntityMembershipPolicyUpdateRequest): Promise<EntityMembershipPolicyDTO> {
    return __request__('PUT', `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, updateRequest, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete a policy
 * @param policyId The ID of the policy to delete
 */
export function remove(policyId?: string): Promise<void> {
    return __request__('DELETE', `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, null, {}, {
        'Accept': ['application/json']
    });
}
